import React from 'react';

import SelectImageButtons from '../SelectImageButtons/SelectImageButtons';
import ProgressBar from '../ProgressBar/ProgressBar';

import preparationsInAdvance from '../../assets/images/preparations-in-advance.png';
import preparationsInAdvance1 from '../../assets/images/preparations-in-advance-1.png';
import styles from './Steps.module.css';

const goalItems = [
  {
    image: preparationsInAdvance,
    value: 1,
    label: 'Yes, I do',
  },
  {
    image: preparationsInAdvance1,
    value: 0,
    label: 'No, I don’t',
  },
];

const Step14 = (props) => {
  const { onSave, stepsData } = props;

  const onSaveHandler = (preparationsInAdvance) => {
    onSave({ 
      preparations_in_advance: preparationsInAdvance
    });
  };

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar />
      <div className={styles.preparationInAdvance}>
        <div className={styles.stepHeader}>
          Do you do meal preparation in advance?
        </div>
        <div className={styles.selectButtonsWrapper}>
          <SelectImageButtons
            buttonsData={goalItems}  
            onChange={onSaveHandler}
            defaultValue={stepsData.preparations_in_advance}
          />
        </div>
        </div>
    </div>
  );
};

export default Step14;